import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=afeacba6&scoped=true&"
import script from "./BaseTag.vue?vue&type=script&lang=js&"
export * from "./BaseTag.vue?vue&type=script&lang=js&"
import style0 from "./BaseTag.vue?vue&type=style&index=0&id=afeacba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeacba6",
  null
  
)

export default component.exports